import { useTranslation } from 'react-i18next';

export type SocialButtonAppearance = 'compact' | 'large' | 'link' | 'tile';

const darkButtonClassName =
  'flex items-center justify-center gap-2 rounded-lg bg-black px-4 py-2 font-heading font-medium text-white [&>svg]:shrink-0';

export const socialButtonClassNames: Record<SocialButtonAppearance, string> = {
  compact: `${darkButtonClassName} h-8 w-full min-w-0 text-sm`,
  large: `${darkButtonClassName} h-12 w-full text-base`,
  link: 'flex w-full items-center justify-center gap-2 font-heading text-xs font-medium text-grey-hide underline',
  tile: 'flex h-12 w-full items-center justify-center gap-2 rounded-lg bg-concrete px-4 py-2'
};

type LabelProps = {
  appearance: SocialButtonAppearance;
  isSubmitting?: boolean;
  name: string;
};

export function SocialButtonLabel({
  appearance,
  isSubmitting,
  name
}: LabelProps) {
  const { t } = useTranslation('common');

  if (isSubmitting) return <span>{t('login.signingIn')}</span>;

  if (appearance === 'tile') {
    return (
      <span className="hidden font-heading font-medium md:inline-block">
        {name}
      </span>
    );
  }

  if (appearance === 'compact') {
    return <span className="sr-only md:not-sr-only">{name}</span>;
  }

  return <span>{t('login.signInWith', { name })}</span>;
}
